import { render, staticRenderFns } from "./SkeletonAdminProduct.vue?vue&type=template&id=f8accd58&scoped=true"
import script from "./SkeletonAdminProduct.vue?vue&type=script&lang=js"
export * from "./SkeletonAdminProduct.vue?vue&type=script&lang=js"
import style0 from "./SkeletonAdminProduct.vue?vue&type=style&index=0&id=f8accd58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8accd58",
  null
  
)

export default component.exports